export default {
	properties: [
		{
			text: 'Porcentaje',
			key: 'percentage',
			type: 'number',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Recargo en blanco',
	plural_model_name_spanish: 'Recargos en blanco',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}